var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3802 8.97378C16.3802 4.52104 12.7664 0.907227 8.31362 0.907227C3.86089 0.907227 0.24707 4.52104 0.24707 8.97378C0.24707 12.878 3.02196 16.1288 6.70031 16.879V11.3937H5.087V8.97378H6.70031V6.95714C6.70031 5.4003 7.96676 4.13385 9.52361 4.13385H11.5402V6.55381H9.92693C9.48327 6.55381 9.12028 6.91681 9.12028 7.36047V8.97378H11.5402V11.3937H9.12028V17C13.1939 16.5967 16.3802 13.1603 16.3802 8.97378Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ebd6df0231dea53236b86579fd6731f3.svg";
export { ForwardRef as ReactComponent };